import { Directive, HostListener, OnInit } from '@angular/core';
import { NgControl } from '@angular/forms';
import { distinctUntilChanged } from 'rxjs';

@Directive({
  standalone: false,
  selector: '[appPhoneMask]',
})
export class PhoneMaskDirective implements OnInit {

  constructor(public ngControl: NgControl) { }

  ngOnInit() {
    this.ngControl.control?.valueChanges.pipe(
      distinctUntilChanged()
    ).subscribe(value => {
      if (value && value !== this.format(value)) {
        this.ngControl.control?.setValue(this.format(value), { emitEvent: false });
      }
    });
  }

  @HostListener('input', ['$event'])
  onInput(event: Event) {
    const inputEvent = event as InputEvent;
    this.onInputChange((inputEvent.target as HTMLInputElement).value, false);
  }

  @HostListener('keydown.backspace', ['$event'])
  keydownBackspace(event:any) {
    this.onInputChange(event.target.value, true);
  }

  onInputChange(value: string, backspace: boolean) {
    if (value) {
      let newVal = value.replace(/\D/g, '');
      if (backspace && newVal.length <= 6) {
        newVal = newVal.substring(0, newVal.length - 1);
      }
      this.ngControl.control?.setValue(this.format(newVal.length === 0 ? '' : newVal), { emitEvent: false });
    }
  }

  private format(value: string): string {
    let newVal = value.replace(/\D/g, '');
    if (newVal.length === 0) return '';
    if (newVal.length <= 3) return newVal.replace(/^(\d{0,3})/, '($1)');
    if (newVal.length <= 6) return newVal.replace(/^(\d{0,3})(\d{0,3})/, '($1) $2');
    newVal = newVal.substring(0, 10);
    return newVal.replace(/^(\d{0,3})(\d{0,3})(\d{0,4})/, '($1) $2-$3');
  }
}